import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { getCatalog } from "@cabinet-packages/redux";
import Catalog from "./Catalog";
import { Loading } from "@cabinet-packages/components";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "max-content",
    minHeight: "100dvh",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingTop: "50px",
  },
  analyzesContainer: {
    height: "200px",
    width: "100%",
    padding: "10px",
    textAlign: "center",
    transition: ".8s",
    border: "2px solid rgb(117, 186, 184)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    backgroundColor: "white",

    "&:hover": {
      background: theme.palette.primary[50],
      cursor: "pointer",
    },
  },
  imgAnalyzes: {
    width: "90px",
    margin: "0 auto",
  },
  mobileWrapperContainer: {
    marginTop: "10px",
    justifyItems: "center",
    paddingBottom: "8px",

    "@media (min-width: 768px)": {
      display: "grid",
      width: "100%",
      height: "100%",
      maxWidth: "900px",
      gridTemplateColumns: "1fr 1fr 1fr 1fr",
      gridGap: "5px",
      gridTemplateRows: "1fr 1fr 1fr 1fr",
      margin: "0 auto",
    },
    "@media (max-width: 768px)": {
      display: "grid",
      gridTemplateColumns: "minMax(150px, 1fr) minMax(150px, 1fr)",
      gridTemplateRows: "repeat(4, minMax(150px, auto))",
      gridGap: "5px",
    },
  },
  titleWrapper: {
    "@media (max-width: 768px)": {
      height: "max-content",
      paddingBottom: "10px",
    },
  },
  analyzesTitle: {
    "@media (max-width: 768px)": {
      fontSize: "14px",
    },
  },
  catalogSwitchControl: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    padding: "10px 0 0 0",
    position: "sticky",
    top: 0,
    alignItems: "baseline",

    "@media (max-width: 768px)": {
      padding: 0,
      paddingTop: "8px",
    },
    "@media (max-width: 900px)": {
      display: "none",
    },
  },
  catalogSwitchControlLabel: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    color: theme.palette.primary.dark,
  },
  catalogWrapper: {
    height: "calc(100dvh - 50px)",
    minHeight: "max-content",
  },
  toggleCheckedCatalogWrapper: {
    height: "max-content",
    maxWidth: "900px",
  },
  error: {
    textAlign: "center",
    height: "100dvh",
    minHeight: "100%",
  },
  catalogTableWrapper: {
    height: "max-content",
  },
}));

const CatalogTable = ({ isComponentInShop }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { catalog, toggleChecked, takeId, complexId, tags } = useSelector(
    (state) => state.assaysCatalog,
  );

  useEffect(() => {
    if (!catalog && takeId && complexId) dispatch(getCatalog());
  }, [catalog, dispatch, takeId, complexId]);

  // console.log(catalog)

  return catalog && catalog !== "error" ? (
        <Catalog isComponentInShop={isComponentInShop} />
  ) : catalog === "error" ? (
    <p className={classes.error}>Вибачте сталась помилка при завантаженні.</p>
  ) : (
    <div className={classes.root}>
      <Loading />
    </div>
  );
};

export default CatalogTable;
